import { Text } from "@chakra-ui/react";
import { colors } from "theme/foundations/colors";

/**
 * Use for page headers
 * @param param0
 * @returns
 */
export const H1 = ({ children, color, ...props }) => (
  <Text as="h1" fontSize="heading.3xl" fontWeight="700" color={color || colors.pageHeader} {...props}>
    {children}
  </Text>
);

/**
 * Use this for headers within a page
 
* TODO replace uses of <Text fontSize="lg" fontWeight="bold"> and similar with this for consistency and maintenance
 */
export const H2 = ({ children, ...props }) => (
  <Text mt={2} mb={1} as="h2" fontSize="heading.m" fontWeight="700" color="gray.600" {...props}>
    {children}
  </Text>
);

/**
 * Use this for headers within a section
 */
export const H3 = ({ children, ...props }) => (
  <Text mt={1} mb={1} as="h3" fontSize="md" fontWeight="bold" color="gray.800" {...props}>
    {children}
  </Text>
);

/**
 * Use this for weak sub headers
 */
export const H4 = ({ children, ...props }) => (
	<Text mt={1} mb={1} as="h4" fontSize="sm" fontWeight="bold" color="gray.800" {...props}>
	  {children}
	</Text>
  );
/**
 * Use this for headers within a dashboard
 *
 * Should it be different to H2??
 */
export const H2Dashboard = ({ children, ...props }) => (
  // <Text as="h3" color="teal" fontSize="heading.s" fontWeight="bold" {...props}>
  <Text color="gray.600" fontSize="heading.m" fontWeight="700" {...props}>
    {children}
  </Text>
);
